'use client';
import React from 'react';

import { Breadcrumbs } from '@/components/breadcrumbs/breadcrumbs';
// import { FloorPlan } from '@/components/floor-plan/floor-plan';
import {
  pageIsTenantEntertainment,
  pageIsTenantFoodBeverage,
  pageIsTenantShop,
} from '@/helpers/list-page/type-guards';
// import { getSeoDescription } from '@/helpers/seo-description';
import { IContentfulImage } from '@/interfaces/contentful-image.interface';
import { IMeetingPlacePageFloorPlan } from '@/lib/fragments/meetingPlacePageFloorPlan';
import { IMeetingplacePageHome } from '@/lib/fragments/meetingPlacePageHome';
// import { PageContext } from '../../../page-context.interface';
import { FloorPlan } from '@/components/floor-plan/floor-plan';
import {
  useTenantConfig,
  useUrlSubDirectoryDictionary,
} from '@/providers/ConfigProvider';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageFloorplanProps {
  metaData: any;
  node_locale: string;
  floorPlanData: {
    floorPlan: IMeetingPlacePageFloorPlan;
    homePage: IMeetingplacePageHome;
  };
  preview: boolean;
}

interface CategoryData {
  name?: string;
  image?: IContentfulImage;
}
export interface FloorPlanCategoriesData {
  shop: CategoryData;
  fb: CategoryData;
  entertainment: CategoryData;
  service: CategoryData;
}

const MeetingPlacePageFloorplan = ({
  metaData,
  node_locale,
  floorPlanData,
  preview,
}: MeetingPlacePageFloorplanProps) => {
  const config = useTenantConfig();
  const urlSubdirectories = useUrlSubDirectoryDictionary();

  const page = floorPlanData?.floorPlan;
  const homepage = floorPlanData?.homePage;
  const tenantList =
    homepage?.meetingPlace?.tenantListPage?.tenantsCollection?.items?.filter(
      Boolean,
    );
  const services =
    homepage?.meetingPlace?.serviceListPage?.servicesCollection?.items?.filter(
      Boolean,
    );

  // // right now giving support for tenantlist as well as individual lists
  const shops =
    homepage?.meetingPlace?.tenantShopListPage?.shopItemsCollection?.items?.filter(
      Boolean,
    );
  const foodBevs =
    homepage?.meetingPlace?.tenantFoodBeverageListPage?.foodBeverageItemsCollection?.items?.filter(
      Boolean,
    );
  const entertainments =
    homepage?.meetingPlace?.tenantEntertainmentListPage?.entertainmentItemsCollection?.items?.filter(
      Boolean,
    );

  const allItems = [
    ...(shops ? shops : []),
    ...(foodBevs ? foodBevs : []),
    ...(entertainments ? entertainments : []),
  ];

  tenantList?.forEach((tenant: any) => {
    const pageExists =
      allItems.filter((item) => item?.sys?.id === tenant?.sys?.id).length > 0;
    if (!pageExists) allItems.push(tenant);
  });

  // Remove all items that don't got a floorPlanID
  const shopList = allItems?.filter(
    (t) => pageIsTenantShop(t) && (t.floorPlanIDs || t?.unitId),
  );
  const entertainmentList = allItems?.filter(
    (t) => pageIsTenantEntertainment(t) && (t.floorPlanIDs || t?.unitId),
  );
  const foodBeverageList = allItems?.filter(
    (t) => pageIsTenantFoodBeverage(t) && (t.floorPlanIDs || t?.unitId),
  );

  const servicesList = services?.filter((s) => s.floorPlanIDs);

  const categoryData: FloorPlanCategoriesData = {
    shop: {
      name: homepage?.meetingPlace?.tenantShopListPage?.name,
      image: page?.shopCategoryImage,
    },
    fb: {
      name: homepage?.meetingPlace?.tenantFoodBeverageListPage?.name,
      image: page?.foodBeverageCatergoryImage,
    },
    entertainment: {
      name: homepage?.meetingPlace?.tenantEntertainmentListPage?.name,
      image: page?.entertainmentCategoryImage,
    },
    service: {
      name: homepage?.meetingPlace?.serviceListPage?.name,
      image: page?.servicesCategoryImage,
    },
  };

  return (
    <>
      {/* ✅ GTM PAGE VIEW */}
      <GtmPageView
        homepage={homepage}
        language={node_locale}
        pageTitle={page?.name ?? ''}
      />
      <main className="pt-27 md:pt-0 md:px-6 lg:-ml-22 lg:bg-transparent lg:px-0">
        {/* <h1>Floor Plan</h1> */}
        <Breadcrumbs
          breadcrumbs={[page?.name ?? '']}
          homeText={homepage.breadcrumbHomeText}
          cssClass="ml-6 lg:ml-22 hidden md:flex"
          node_locale={node_locale}
        // parent={pageContext.parent}
        />

        <FloorPlan
          page={page}
          homepage={homepage}
          mapHash={homepage?.meetingPlace?.visioGlobeMapKey ?? ''}
          node_locale={node_locale}
          serviceList={servicesList}
          tenantEntertainmentList={entertainmentList}
          tenantFbList={foodBeverageList}
          tenantShopList={shopList}
          categoryData={categoryData}
          config={config}
          urlSubdirectories={urlSubdirectories}
        />
      </main>
    </>
  );
};

export default MeetingPlacePageFloorplan;
